import { createSelector } from 'reselect';

export const localStorageSelector = (state) => state.get('localStorage');

export const savedPlansSelector = createSelector(
  localStorageSelector,
  (state) => state.get('savedPlans').toJS()
);

export const getPlanNameSelector = createSelector(
  savedPlansSelector,
  (savedPlans) => (code) => ((savedPlans.find((sp) => code === sp.code) || {}).name)
);

export const hasSavedPlansSelector = createSelector(
  savedPlansSelector,
  (savedPlans) => savedPlans.length > 0
);

export const lastVersionSelector = createSelector(
  localStorageSelector,
  (state) => state.get('lastVersion')
);

export const hasSeenNewFeaturesSelector = createSelector(
  localStorageSelector,
  (state) => state.get('hasSeenNewFeatures')
);

export const checkedSavedPlansSelector = createSelector(
  savedPlansSelector,
  (savedPlans) => savedPlans.filter((plan) => plan.checked),
);

export const hasLoadedOldPlanSelector = createSelector(
  localStorageSelector,
  (state) => state.get('hasLoadedOldPlan')
);

export const hasClosedProductMessageSelector = createSelector(
  localStorageSelector,
  (state) => state.get('hasClosedProductMessage')
);
